import { getUserInfo, hasAdminAuth } from "api/commonUtil";
import { sendGet } from "api/restUtil";
import { isEmptyArray, openDraftViewPopup } from "js/common";
import React, { useState, useEffect } from "react";
import { useNavigate} from "react-router-dom";

function Main(props) {
	let navigate = useNavigate();

	const [mainData, setMainData] = useState({}); //메인화면 데이터

	useEffect(() => {
		// getMainData();

		// window.refreshList = () => {
		// 	getMainData();
		// }
	}, []);

	const getMainData=async()=> {
		sendGet("/api/main-data")
		.then((result)=> {
			if(result.respCode === "SUCCESS") {
				setMainData(result.data);
			}
		})
	}

	return (
		<div className="egov-container">
			<div className="c_wrap">
				<div className="logo-center-container">
					<div className ="main_menu_container">

						{getUserInfo()?.userType === "SYSADMIN" && (
							<>
							<ul>
								<li>시스템 관리자만 볼 수 있는 메모</li>
							</ul>
							</>
						)}

					</div>
				</div>
			</div>
		</div>
	);
}

export default Main;
